import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage, getSenderManagementTranslation } from '../../hooks/useLanguage';

export const SendersTable = ({ senders, isLoading, handleEdit, openDeleteModal }) => {
    const [isSpanish] = useLanguage();
    const [openDropdownId, setOpenDropdownId] = useState(null);
    return (
        <table className="min-w-full border-collapse border border-gray-300 mt-4 text-sm">
            <thead>
                <tr>
                    <th className="border border-gray-300 p-2">{getSenderManagementTranslation('senderName', isSpanish)}</th>
                    <th className="border border-gray-300 p-2">{getSenderManagementTranslation('senderTaxId', isSpanish)}</th>
                    <th className="border border-gray-300 p-2">{getSenderManagementTranslation('senderEori', isSpanish)}</th>
                    <th className="border border-gray-300 p-2">{getSenderManagementTranslation('senderAddress', isSpanish)}</th>
                    <th className="border border-gray-300 p-2">{getSenderManagementTranslation('senderCity', isSpanish)}</th>
                    <th className="border border-gray-300 p-2">{getSenderManagementTranslation('senderCountry', isSpanish)}</th>
                    <th className="border border-gray-300 p-2">{getSenderManagementTranslation('actions', isSpanish)}</th>
                </tr>
            </thead>
            <tbody>
                {senders && senders.length > 0 ? (
                    senders.map((sender) => (
                        sender && (
                            <tr key={sender.id}>
                                <td className="border border-gray-300 p-2">{sender.nombre}</td>
                                <td className="border border-gray-300 p-2">{sender.identificacion_fiscal}</td>
                                <td className="border border-gray-300 p-2">{sender.eori}</td>
                                <td className="border border-gray-300 p-2">{sender.direccion}</td>
                                <td className="border border-gray-300 p-2">{sender.localidad}</td>
                                <td className="border border-gray-300 p-2">{sender.pais}</td>
                                <td className="border border-gray-300 p-2 w-fit">
                                    <div className='relative text-sm'>
                                        <button 
                                            className={`flex gap-2 justify-between items-center border-containera bg-gray-100 hover:bg-gray-200 rounded-full p-2 px-4 w-full`} 
                                            onClick={() => {
                                                const dropdownKey = `${sender.id}`;
                                                setOpenDropdownId(openDropdownId === dropdownKey ? null : dropdownKey);
                                            }}
                                            disabled={isLoading}
                                        >
                                            <p className='truncate'>{getSenderManagementTranslation('selectAction', isSpanish)}</p>
                                            <ChevronDown className={`w-4 h-4 ${openDropdownId === `${sender.id}` && "rotate-180"}`} />
                                        </button>
                                        {openDropdownId === `${sender.id}` && (
                                            <div className='min-w-52 right-0 flex flex-col absolute z-10 bg-white mt-1 w-full border-containera shadow-md rounded-xl max-h-80 overflow-auto p-2'>
                                                <p className='opacity-75 px-2 py-1 text-xs'>{getSenderManagementTranslation('selectAction', isSpanish) || (isSpanish ? 'Seleccionar Acción' : 'Select Action')}</p>
                                                <span 
                                                    className="px-2 py-1 hover:bg-gray-100 cursor-pointer rounded-full"
                                                    onClick={() => {
                                                        handleEdit(sender);
                                                        setOpenDropdownId(null);
                                                    }}
                                                >
                                                    {getSenderManagementTranslation('edit', isSpanish)}
                                                </span>
                                                <span 
                                                    className='px-2 py-1 hover:bg-gray-100 cursor-pointer rounded-full' 
                                                    onClick={() => {
                                                        openDeleteModal(sender);
                                                        setOpenDropdownId(null);
                                                    }}
                                                >
                                                    {getSenderManagementTranslation('delete', isSpanish)}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )
                    ))
                ) : (
                    <tr>
                        <td colSpan="7" className="border border-gray-300 p-2 text-center">
                            {getSenderManagementTranslation('noSendersFound', isSpanish)}
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}